import React, { Component } from 'react';
import { AccordionItem } from 'carbon-components-react';
import { toast } from 'react-toastify';
import TitleAccordionPortfolioProfile from './TitleAccordionPortfolioProfile';
import { getDmService } from '../../../services/Api';

class PortfolioProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dados: [],
    };
  }

  componentWillMount = async () => {
    await this.getItems();
  };

  getItems = async () => {
    try {
      const dados = await getDmService(`/Usuario/Carteira/`);
      this.setState({ dados });
    } catch (ex) {
      toast.error('Ocorreu uma falha ao carregar os dados');
    }
  };

  render() {
    const { dados } = this.state;
    return (
      <div className="">
        <div className="bx--row">
          <div className="bx--col-xs-12">
            {dados.map(item => (
              <div className="carteira-perfil" key={item.id}>
                <AccordionItem
                  key={item.id}
                  title={(() => (
                    <TitleAccordionPortfolioProfile
                      total={item.lojas.length}
                      nome={item.nome}
                      codCli={item.id}
                    />
                  ))()}
                >
                  <ul className="list-carteira-perfil">
                    {item.lojas.map(loja => (
                      <li key={loja.id}>{loja.nome}</li>
                    ))}
                  </ul>
                </AccordionItem>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}

export default PortfolioProfile;



// WEBPACK FOOTER //
// ./src/screens/client/profile/Portfolio.jsx